export default __webpack_public_path__ + "static/media/3.ab52427b.png";